import { Box, Flex, Spinner } from '@fullstory/components';
import React from 'react';

export const CardSpinner: React.FC<{
  height: number;
}> = ({ height }) => (
  <Box data-component="CardSpinner" height={height}>
    <Flex justifyContent="center" alignItems="center" style={{ height: '100%' }}>
      <Spinner />
    </Flex>
  </Box>
);
